export const GET_PLACES = 'GET_PLACES';

export enum ENUM_CLOUD_ACTIVATION_REQUEST_STATUS {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  RESERVE_BASE = 'RESERVE_BASE',
}

export const TRANSLATE_CLOUD_ACTIVATION_REQUEST_STATUS: Record<
  ENUM_CLOUD_ACTIVATION_REQUEST_STATUS,
  string
> = {
  [ENUM_CLOUD_ACTIVATION_REQUEST_STATUS.APPROVED]: 'Aprovado',
  [ENUM_CLOUD_ACTIVATION_REQUEST_STATUS.PENDING]: 'Pendente',
  [ENUM_CLOUD_ACTIVATION_REQUEST_STATUS.RESERVE_BASE]: 'Base cadastral',
};

export const OPTIONS_CLOUD_ACTIVATION_REQUEST_STATUS: {
  key: ENUM_CLOUD_ACTIVATION_REQUEST_STATUS;
  text: string;
  value: ENUM_CLOUD_ACTIVATION_REQUEST_STATUS;
}[] = [
  {
    key: ENUM_CLOUD_ACTIVATION_REQUEST_STATUS.APPROVED,
    text: TRANSLATE_CLOUD_ACTIVATION_REQUEST_STATUS.APPROVED,
    value: ENUM_CLOUD_ACTIVATION_REQUEST_STATUS.APPROVED,
  },
  {
    key: ENUM_CLOUD_ACTIVATION_REQUEST_STATUS.PENDING,
    text: TRANSLATE_CLOUD_ACTIVATION_REQUEST_STATUS.PENDING,
    value: ENUM_CLOUD_ACTIVATION_REQUEST_STATUS.PENDING,
  },
  {
    key: ENUM_CLOUD_ACTIVATION_REQUEST_STATUS.RESERVE_BASE,
    text: TRANSLATE_CLOUD_ACTIVATION_REQUEST_STATUS.RESERVE_BASE,
    value: ENUM_CLOUD_ACTIVATION_REQUEST_STATUS.RESERVE_BASE,
  },
];

export enum ENUM_TICKET {
  BOLETO = 'BOLETO',
  PIX = 'PIX',
}
